export var masterFirebaseConfig = {
   apiKey: "AIzaSyDww3AzqKDgy8XM9yW37FGKhIsqaeMaVCs",
   authDomain: "space-janitor.firebaseapp.com",
   databaseURL: "https://space-janitor.firebaseio.com",
   projectId: "space-janitor",
   storageBucket: "",
   messagingSenderId: "80047333601"
 };



// WEBPACK FOOTER //
// /Users/Guest/Desktop/Space-Janitor/src/app/api-keys.ts